const { code, empty, responseError } = require('./booking-detail')

const personalFields = ['first_name', 'last_name', 'gender', 'dob', 'age', 'citizenship', 'passport_number', 'passport_country', 'passport_expiration_date', 'phone', 'email']
const passengerGroups = [
  { code: 'adult', field: 'adult', name: 'Adults', singular: 'Adult' },
  { code: 'child', field: 'child', name: 'Children', singular: 'Child' },
  { code: 'infant', field: 'infant', name: 'Infants', singular: 'Infant' }
]

function passengerData(passenger, hasLead, completed) {
  return hasLead && !completed ? passenger.client || {} : passenger
}
function passengerName(passenger, hasLead, completed) {
  const data = passengerData(passenger, hasLead, completed)
  const name = [data.first_name, data.last_name].filter(value => !empty(value)).join(' ')
  return name ? [data.title, name].filter(value => !empty(value)).join(' ') : `${(passengerGroups.find(group => group.code === code(passenger.age_type)) || {}).singular || 'Unknown'} passenger`
}
function passengerPayload(passenger) {
  const payload = {}
  for (const field of [...personalFields, 'carrying_infant_passenger_id']) {
    const value = passenger[field]
    payload[field] = empty(value) ? null : ['age', 'carrying_infant_passenger_id'].includes(field) ? Number(value) : typeof value === 'string' ? value.trim() : code(value)
  }
  return payload
}

function calendarDay(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}
function todayInEAT(now = Date.now()) {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Dar_es_Salaam', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date(now))
  const values = Object.fromEntries(parts.map(part => [part.type, part.value]))
  return `${values.year}-${values.month}-${values.day}`
}
function passengerDateErrors(passenger, now = Date.now()) {
  const errors = {}
  const today = todayInEAT(now)
  for (const [field, message] of [['dob', 'Date of birth must be before today.'], ['passport_expiration_date', 'Passport expiry must be after today.']]) {
    const value = passenger[field]
    if (empty(value)) continue
    const parsed = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T00:00:00Z`) : null
    if (!parsed || !Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== value) errors[field] = 'Enter a valid date.'
    else if (field === 'dob' ? value >= today : value <= today) errors[field] = message
  }
  return errors
}
function passengerRequestErrors(error, fields = []) {
  const data = error && error.response && error.response.data
  const nested = data && (data.details || data.detail)
  const details = nested && typeof nested === 'object' ? nested : data
  if (!details || typeof details !== 'object' || Array.isArray(details)) return { fields: {}, message: responseError(error) }
  const fieldErrors = {}
  const general = {}
  for (const [key, value] of Object.entries(details)) {
    const message = Array.isArray(value) ? value.join(', ') : String(value)
    if (fields.includes(key)) fieldErrors[key] = message
    else general[key] = value
  }
  return { fields: fieldErrors, message: Object.keys(general).length ? responseError({ response: { data: general } }) : '' }
}

module.exports = { personalFields, passengerGroups, passengerData, passengerName, passengerPayload, calendarDay, todayInEAT, passengerDateErrors, passengerRequestErrors }
